var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SimpleAppTable',{staticClass:"device-stats-table",attrs:{"data-props":_vm.tableProps,"table-list":_vm.tableList,"custom-components":_vm.customComponents,"loading":{ process: _vm.loadingTable }}})
}
var staticRenderFns = []

export { render, staticRenderFns }